/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDeliveryQuote} from '../api'

 export const useQueryGetDeliveryQuote = createReactQueryHook('getDeliveryQuote', getDeliveryQuote)
